// Parses the backend's "Transcribe" completion notification (the SSE that
// tells the client a transcription finished) into { recordingId, error }.
//
// The notification's `type` field is HARDCODED "success" server-side — even
// for genuine STT failures whose text says "service error ... The audio is
// not lost". Branching on type alone therefore routed every failure through
// the success path, where the native app marks the recording parsed and
// DELETES its local audio — destroying the very audio the message promised
// was safe. The honest failure signal is the 4th metadata token the backend
// now appends: `"transcribe <chatId> <recordingId> error"`. Old backends send
// only 3 tokens (treated as success, their historical behavior); the type
// check is kept for any future backend that types errors properly.
export function parseTranscribeNotification(notification) {
  const parts = String(notification?.metadata || "").split(" ");
  const recordingId = parts[2];
  const failed = notification?.type !== "success" || parts[3] === "error";
  return {
    recordingId,
    error: failed ? notification?.text || "Error" : null,
  };
}
